<template>
  <div class='upload-certificates-form'>
    <div class="add-certificate-form">
      <div class="certificates-inputs" v-for="(value, index) in manualCertificates" :key="index">
        <div class="text-field-section">
          <text-field
            type="text"
            v-model="manualCertificates[index].name"
            class="login"
            :label="$t('certificate.add.manual.label')"
            :placeholder="$t('certificate.add.manual.placeholder')"
          />
          <CertificateScan
            v-if="manualCertificates[index].name"
            :certificateCode="index"
            :is-manual="true"
            @changed="formChanged"
          />
        </div>
        <div class="add-new-certificate-section">
          <v-btn color='#B331CF' v-if='index === manualCertificates.length-1' :disabled="!manualCertificates[index].name" class="add-btn" @click="addManualCertificate">
            <span class="plus">+</span>{{ $t('certificate.add.manual.add.button') }}
          </v-btn>
        </div>
      </div>
    </div>
    <div v-for="(certificate) in spCompanyCertificates" :key="certificate.code">
      <custom-checkbox
        :title="$t(`${certificate.code}`)"
        :value="checkBoxValues[certificate.code]"
        class="feature-checkbox"
        color="cold-marine"
        @input="onSelect(certificate)"
      />
      <CertificateScan
        v-if="checkBoxValues[certificate.code]"
        :certificateCode="certificate.code"
        :is-manual="false"
        @changed="formChanged"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import TextField from '@/components/common/TextField.vue';
import CustomCheckbox from '@/components/common/CustomCheckbox.vue';
import CertificateScan from '@/components/spFreelancerRegistration/CertificateScan.vue';

export default {
  name: 'CompanySPUploadCertificationsForm',
  components: { CustomCheckbox, TextField, CertificateScan },
  data() {
    return {
      manualCertificates: [{name: '', file: ''}],
      certificatesListChosen: [],
      selectedFile: {},
      isSelecting: false,
    };
  },
  mounted() {
    this.fileReader = new FileReader();
    this.fileReader.onload = this.onFileReaded;
  },
  computed: {
    ...mapGetters([
      'spCompanyCertificates',
      'spCompanyRegistrationCompanyCertificationInfo',
    ]),
    checkBoxValues() {
      const certificatesValueObject = {};
      this.spCompanyCertificates.forEach(certificate => {
        certificatesValueObject[certificate.code] = this.certificatesListChosen.includes(certificate.code);
      });
      return certificatesValueObject;
    },
    allCertificatesInfo() {
      const defaultCertificatesWithScanData = [];
      this.certificatesListChosen.forEach(certificate => {
        if (Object.keys(this.selectedFile).includes(certificate)) {
          defaultCertificatesWithScanData.push({
            code: certificate,
            file: this.selectedFile[certificate],
          });
        } else {
          defaultCertificatesWithScanData.push({
            code: certificate,
            file: null,
          });
        }
      });
      return {
        manualCertifications: this.manualCertificates,
        defaultCertifications: defaultCertificatesWithScanData,
      };
    },
  },
  methods: {
    addManualCertificate() {
      this.manualCertificates.push({ name: '', file: '' });
    },
    async formChanged(value) {
      if (value?.isManual) {
        this.manualCertificates[value.code].file = value.file;
      } else {
        this.selectedFile[value?.code] = value?.file;
      }
      await this.$emit('onCertificationDataChanged', this.allCertificatesInfo);
    },
    onSelect(certificate) {
      if (!this.certificatesListChosen.includes(certificate.code)) {
        this.certificatesListChosen.push(certificate.code);
      } else {
        const index = this.spCompanyCertificates.findIndex(element => element === certificate.code);
        this.certificatesListChosen.splice(index, 1);
      }
    },
  },
  watch: {
    certificatesListChosen: {
      handler(value) {
        this.formChanged(value);
      },
      deep: true,
    },
  },
};
</script>
<style lang='scss' scoped>
@import '~@/assets/styles/design-system';

.v-text-field.v-text-field--enclosed .v-text-field__details {
  display: none !important;
}

.upload-certificates-form {
  height: rem(311);
  overflow-y: scroll;
  overflow-x: hidden;
  margin-bottom: rem(40);

  .file-name {
    height: rem(16);
    color: $auth-text-muted;
    font-family: $font-family-medium;
    font-size: rem(12);
    font-weight: 500;
    letter-spacing: rem(1.07);
    line-height: rem(16);
    text-align: center;
  }
}

.checkbox-container {
  margin-bottom: rem(10) !important;
}

.btn-text-upload-scan {
  height: rem(16);
  width: rem(132);
  color: #5c6670;
  font-family: $font-family-medium;
  font-size: rem(12);
  font-weight: 500;
  letter-spacing: rem(1.07);
  line-height: rem(16);
  text-align: center;
}

.add-certificate-form {
  margin-bottom: rem(32);

  .certificates-inputs {
    display: flex;

    .text-field-section {
      flex: 0 0 75%;
    }

    .add-new-certificate-section {
      color: #9BB0BE;
      font-family: $font-family-regular;
      font-size: rem(12);
      font-weight: 500;
      letter-spacing: rem(1.07);
      line-height: rem(16);
      text-align: center;
      flex: 1;
      height: rem(32);
      margin-top: rem(17);

      .plus {
        font-size: rem(16);
        margin-top: rem(-3);
      }

      .add-btn {
        width: rem(86);
        color: #FFFFFF;
      }
    }
  }
}
</style>
